var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "cmp cmp-product-thumb bordered",
      attrs: { "data-testing": _vm.item.variation.id }
    },
    [
      _c(
        "div",
        { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
        [
          _c(
            "div",
            { staticClass: "add-to-basket-btn d-none" },
            [
              _c("add-to-basket", {
                attrs: {
                  "data-testing": "item-add-to-basket",
                  "variation-id": _vm.item.variation.id,
                  "is-salable": !!_vm.item.filter && _vm.item.filter.isSalable,
                  "has-children":
                    !!_vm.item.item && _vm.item.item.salableVariationCount > 1,
                  "interval-quantity":
                    _vm.item.variation.intervalOrderQuantity || 1,
                  "minimum-quantity": _vm.item.variation.minimumOrderQuantity,
                  "maximum-quantity":
                    !!_vm.item.variation.maximumOrderQuantity &&
                    _vm.item.variation.maximumOrderQuantity > 0
                      ? _vm.item.variation.maximumOrderQuantity
                      : null,
                  "order-properties": _vm.item.properties.filter(function(
                    prop
                  ) {
                    return prop.property.isOderProperty
                  }),
                  "has-order-properties": _vm.item.hasOrderProperties,
                  "has-required-order-property":
                    _vm.item.hasRequiredOrderProperty,
                  "use-large-scale": true,
                  "show-quantity": false,
                  "item-url": _vm._f("itemURL")(
                    _vm.item,
                    _vm.urlWithVariationId
                  ),
                  "has-price": _vm._f("hasItemDefaultPrice")(_vm.item),
                  "has-graduated-price":
                    _vm.itemGraduatedPriceisCheapestSorting ||
                    _vm.itemGraduatedPricesalableVariationCount,
                  "item-type": _vm.item.item.itemType
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "thumb-image" }, [
            _c(
              "div",
              { staticClass: "prop-1-1" },
              [
                _vm._t("item-image", [
                  _c("category-image-carousel", {
                    ref: "categoryImageCarousel",
                    attrs: {
                      "image-urls-data": _vm._f("itemImages")(
                        _vm.item.images,
                        _vm.imageUrlAccessor
                      ),
                      alt: _vm._f("itemName")(_vm.item),
                      "item-url": _vm._f("itemURL")(
                        _vm.item,
                        _vm.urlWithVariationId
                      ),
                      "enable-carousel":
                        _vm.$ceres.config.item.enableImageCarousel,
                      "disable-carousel-on-mobile": _vm.disableCarouselOnMobile
                    }
                  })
                ])
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm._t("store-special", [
            _vm.storeSpecial ||
            _vm.item.variation.bundleType === "bundle" ||
            _vm.item.item.itemType === "set"
              ? _c("item-store-special", {
                  attrs: {
                    "store-special": _vm.storeSpecial,
                    "recommended-retail-price": _vm.item.prices.rrp,
                    "variation-retail-price": _vm.item.prices.default,
                    "special-offer-price": _vm.item.prices.specialOffer,
                    "decimal-count": _vm.decimalCount,
                    "bundle-type": _vm.item.variation.bundleType,
                    "item-type": _vm.item.item.itemType
                  }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm._t("item-details", [
            _c(
              "div",
              { staticClass: "thumb-content" },
              [
                _c(
                  "a",
                  {
                    staticClass: "thumb-title mb-lg-5",
                    class: {
                      "stretched-link":
                        _vm.$ceres.config.global.shippingCostsCategoryId == 0
                    },
                    attrs: {
                      href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId)
                    }
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(_vm._f("itemName")(_vm.item))
                    ),
                    _vm._l(_vm.item.groupedAttributes, function(attribute) {
                      return _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("translate")(
                              "Ceres::Template.itemGroupedAttribute",
                              attribute
                            )
                          )
                        )
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "thumb-meta mt-2" },
                  [
                    _vm._t("before-prices"),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column-reverse flex-xl-row" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "availability-preview text-uppercase small align-self-end py-1mt-2 mt-xl-0 font-weight-bold",
                            class:
                              "availability-" +
                              _vm.item.variation.availability.id
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.item.variation.availability.names.name
                                ) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "prices flex-column align-items-end justify-content-end"
                          },
                          [
                            _vm.item.prices.rrp &&
                            _vm.item.prices.rrp.price.value > 0 &&
                            _vm.item.prices.rrp.price.value >
                              _vm.item.prices.default.price.value
                              ? _c("div", { staticClass: "price-view-port" }, [
                                  _vm.item.prices.specialOffer
                                    ? _c("del", { staticClass: "crossprice" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm._f("itemCrossPrice")(
                                                _vm.item.prices.default
                                                  .unitPrice.formatted,
                                                true
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    : _c("del", { staticClass: "crossprice" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm._f("itemCrossPrice")(
                                                _vm.item.prices.rrp.unitPrice
                                                  .formatted
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "price" },
                              [
                                _vm.item.item.itemType === "set"
                                  ? [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.itemSetPrice",
                                              { price: _vm.itemSetPrice }
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  : _vm.itemGraduatedPriceisCheapestSorting
                                  ? [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.itemFromPrice",
                                              { price: _vm.itemPriceGraduated }
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  : _vm.itemGraduatedPricesalableVariationCount
                                  ? [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.itemFromPrice",
                                              { price: _vm.itemPriceGraduated }
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  : [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm._f("specialOffer")(
                                              _vm.item.prices.default.unitPrice
                                                .formatted,
                                              _vm.item.prices,
                                              "unitPrice",
                                              "formatted"
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                              ],
                              2
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._t("after-prices"),
                _vm._v(" "),
                _vm.item.prices.default.lowestPrice.value && _vm.hasCrossPrice
                  ? _c("div", { staticClass: "category-lowest-price small" }, [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$translate("Ceres::Template.itemLowestPrice", {
                              price:
                                _vm.item.prices.default.lowestPrice.formatted
                            })
                          )
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "add-to-basket-mobile-btn d-none" },
                  [
                    _c("add-to-basket", {
                      attrs: {
                        "variation-id": _vm.item.variation.id,
                        "is-salable":
                          !!_vm.item.filter && _vm.item.filter.isSalable,
                        "has-children":
                          !!_vm.item.item &&
                          _vm.item.item.salableVariationCount > 1,
                        "interval-quantity":
                          _vm.item.variation.intervalOrderQuantity || 1,
                        "minimum-quantity":
                          _vm.item.variation.minimumOrderQuantity,
                        "maximum-quantity":
                          !!_vm.item.variation.maximumOrderQuantity &&
                          _vm.item.variation.maximumOrderQuantity > 0
                            ? _vm.item.variation.maximumOrderQuantity
                            : null,
                        "order-properties": _vm.item.properties.filter(function(
                          prop
                        ) {
                          return prop.property.isOderProperty
                        }),
                        "has-required-order-property":
                          _vm.item.hasRequiredOrderProperty,
                        "has-order-properties": _vm.item.hasOrderProperties,
                        "use-large-scale": false,
                        "show-quantity": false,
                        "item-url": _vm._f("itemURL")(
                          _vm.item,
                          _vm.urlWithVariationId
                        ),
                        "has-price": _vm._f("hasItemDefaultPrice")(_vm.item),
                        "has-graduated-price":
                          _vm.itemGraduatedPriceisCheapestSorting ||
                          _vm.itemGraduatedPricesalableVariationCount,
                        "item-type": _vm.item.item.itemType
                      }
                    })
                  ],
                  1
                )
              ],
              2
            )
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }